module.exports = __webpack_public_path__ + "media/images/flags/MR-a0cda7e4fe2e6c0f845592b3006ab149.svg";